/**
 *  Video plugin or system module implementation.
 *  Same interface with audio provider from embedded magcore.
 */

'use strict';

var request = require('./request'),
    Track = require('./track'),
    List = require('./list'),
    prepareUrl = require('./prepareUrl');


function Provider () {
    this.requestLinks = {};
}


Provider.prototype = {};
Provider.prototype.constructor = Provider;


/**
 * Get tracks list.
 *
 * @param {Object} config - filters configuration
 * @param {Function} callback - result handler
 */
Provider.prototype.getTracks = function ( config, callback ) {
    request(
        prepareUrl('audio-tracks', config),
        {
            method: 'GET',
            onload: function ( error, response ) {
                var data = [],
                    index;

                if ( !error ) {
                    for ( index = 0; index < response.data.length; index++ ) {
                        data[index] = new Track(response.data[index]);
                    }
                }

                callback(error, data, error ? 0 : response.paging.total);
            },
            onerror: callback
        },
        'getTracks',
        this.requestLinks
    );
};


/**
 * Get playlists list.
 *
 * @param {Object} config - request config
 * @param {Function} callback - result handler
 */
Provider.prototype.getPlaylists = function ( config, callback ) {
    request(
        prepareUrl('audio-playlists', config),
        {
            method: 'GET',
            onload: function ( error, response ) {
                var data = [],
                    index;

                if ( !error ) {
                    for ( index = 0; index < response.data.length; index++ ) {
                        data[index] = new List(response.data[index]);
                    }
                }

                callback(error, data, error ? null : response.paging.total);
            },
            onerror: callback
        },
        'getPlaylists',
        this.requestLinks
    );
};


/**
 * Create playlist.
 *
 * @param {Object} config - request config
 * @param {Function} callback - result handler
 */
Provider.prototype.createPlaylist = function ( config, callback ) {
    request(
        'audio-playlists',
        {
            method: 'POST',
            body: JSON.stringify(config),
            onload: function ( error, response ) {
                if ( callback ) {
                    callback(error, error ? {} : new List(response.data));
                }
            },
            onerror: callback
        }
    );
};


/**
 * Get all playlists list.
 *
 * @param {Function} callback - result handler
 * @param {Array} result - previous steps result
 */
Provider.prototype.getAllPlaylists = function ( callback, result ) {
    var self = this,
        config;

    result = result || [];

    config = {
        limit: 200,
        offset: result.length
    };

    request(
        prepareUrl('audio-playlists', config),
        {
            method: 'GET',
            onload: function ( error, response ) {
                var data = [],
                    index;

                if ( !error ) {
                    for ( index = 0; index < response.data.length; index++ ) {
                        data[index] = new List(response.data[index]);
                    }

                    result = result.concat(data);
                    if ( response.paging.total > result.length ) {
                        self.getAllPlaylists(callback, result);

                        return;
                    }
                }

                callback(error, result);

            },
            onerror: callback
        },
        'getPlaylists',
        this.requestLinks
    );
};


/**
 * Get albums list.
 *
 * @param {Object} config - request config
 * @param {Function} callback - result handler
 */
Provider.prototype.getAlbums = function ( config, callback ) {
    request(
        prepareUrl('audio-albums', config),
        {
            method: 'GET',
            onload: function ( error, response ) {
                callback(error, error ? [] : response.data, error ? null : response.paging.total);
            },
            onerror: callback
        },
        'getAlbums',
        this.requestLinks
    );
};


/**
 * Get artists list.
 *
 * @param {Object} config - request config
 * @param {Function} callback - result handler
 */
Provider.prototype.getArtists = function ( config, callback ) {
    request(
        prepareUrl('audio-artists', config),
        {
            method: 'GET',
            onload: function ( error, response ) {
                callback(error, error ? [] : response.data, error ? null : response.paging.total);
            },
            onerror: callback
        },
        'getArtists',
        this.requestLinks
    );
};


/**
 * Get years list.
 *
 * @param {Function} callback - result handler
 */
Provider.prototype.getYears = function ( callback ) {
    request(
        'audio-years',
        {
            method: 'GET',
            onload: function ( error, response ) {
                if ( response.error ) {
                    error = true;
                }
                if ( callback ) {
                    callback(error, response);
                }
            },
            onerror: callback
        }
    );
};


/**
 * Get genres list.
 *
 * @param {Function} callback - result handler
 */
Provider.prototype.getGenres = function ( callback ) {
    request(
        'audio-genres',
        {
            method: 'GET',
            onload: function ( error, response ) {
                if ( response.error ) {
                    error = true;
                }
                if ( callback ) {
                    callback(error, response);
                }
            },
            onerror: callback
        }
    );
};


module.exports = Provider;
